export default "__VITE_PUBLIC_ASSET__987222c9__"